import styled from 'styled-components';

export const DivPreview = styled.div`
  /* width: 100%; */
  /* height: 100%; */
  /* position: relative; */
  text-align: center;
`;

export const ImgPreview = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 0.1rem;
`;

export const WrapperDiv = styled.div`
  height: 100%;
  width: 100%;
  padding: 2rem;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: ${(p) => p.theme.background};
  text-align: center;
`;

export const ImgDiv = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Img = styled.img`
  width: 100%;
`;

export const BackgroundContainer = styled.div`
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 0.2rem;
  background-color: black;
  box-sizing: border-box;  
  `;

export const ButtonsContainer = styled.div`
  @media only screen and (orientation:landscape) {
    display: none;
  } 
  button{
      width: 15rem;
  }
  margin-top:20rem;
  position:absolute;
  width: 100%;
  height: 5rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
`;

export const CameraContainer = styled.div`
position: relative;
width: 100%;
height: 100%;
border-radius: 20px;
`;

export const SilhouetteImage1 = styled.img`
  max-width: 360px;
  max-height: 550px;
  display: block; 
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const SilhouetteImage = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const OvalOuter = styled.div`
  width: 120%;
  height: 100%;
  background: radial-gradient(ellipse at center, transparent 50%, transparent 53%, rgba(255,255,255,255) 50%);
  background-clip: content-box;
  filter: blur(1px);
  position: absolute;
  
`;
export const OvalInner = styled.div`
  width: 100%;
  height: 80%;
  background: transparent;
  border: 3px solid transparent;
  border-radius: 50%;
  position: relative;
`;